import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16;
  color: ${p => p.theme.colors.main};
`;
